import utils from './common/utility.js';
//import settings from './ib-ads-lib/settings.js';
import SetProfSizes from './common/SetProfSizes';
import wbmdObject from './common/webmdObject';
import Webmd from './common/webmdAds2.js';

import medianet from './medscape/third-parties/medianet';
import meads from './medscape/third-parties/meads';
import doubleVerify from './medscape/third-parties/doubleVerify';
import { debug } from './common/debug-log';
import staticTargetKeys from './common/staticTargetKeys';
import dynamicTargetkeys from './common/dynamicTargetKeys';
import ProfAdsIgnore from './common/ProfAdsIgnore.js';
import addRepConnect from './common/mdscp-rep-connect.js';
import formulary from './common/formulary-callback.js';

window.ibAds = window.ibAds || {};
window.webmd = window.webmd || {};
webmd.object = wbmdObject;
webmd.ads2 = new Webmd();
window.checkHTML5Creative = true;

// initialize the webmd.tpsvc namespace
webmd.tpsvc = webmd.tpsvc || {};

// initialize the webmd.tps command queue - a queue for storing third party service commands
webmd.tpsvc.cmds = webmd.tpsvc.cmds || [];

// if the 3rd-party service implements a promise, initialize the webmd.tpsvc promise queue
// the promise is a placeholder into which response from the 3rd-party service is inserted.
webmd.tpsvc.promises = webmd.tpsvc.promises || [];

// Meads ipon global variables
window.oldPositions = {};
window.oldMEpos = [];
window.enableME = true;
//end of Meads
window.profads = {};
const referenceKeys = [ 'pos', 'usp', 'ssp', 'env', 'pub', 'art', 'cg', 'dmp', 'mapp', 'kw', 'pc', 'sec', 'spon', 'tar', 'tc', 'll', 'uri', 'auth', 'ct', 'asid', 'occ', 'pf', 'scg', 'st', 'ppub', 'acb', 'mnrf', 'medcase', 'sname', 'medsec', '', 'mniv', 'rord', 'imid', 'mop', 'mcs', 'pvid', 'moa', 'auu', 'val', 'mob', 'oaw', 'envp', 'pai', 'pae', 'usoo', 'ep', 'path3', 'sa', 'path2', 'dt', 'ac', 'as', 'al', 'rd', 'isValid', 'ck', 'usps', 'ad_slot', 'path1', 'pg', 'bp', 'gd', 'lif', 'ecd', 'vp', 'fpt', 'acs', 'pvb', 'cn', 'pgr', 'mnetNative', 'dis', 'actid', 'aamid', 'masid', 'mnetUGD', 'mnetCV', 'vit', 'stick', 'xgdp', 'iaf', 'm_data', 'm_safety', 'm_categories', 'm_mv', 'm_gv', 'oid', 'mnetPageID', 'mnetCC', 'mnetCID', 'mnetDNB', 'ctype', 'tug', 'huid','eed' ].map(k=>k.toLowerCase());
const unMatchedKeys = [];
const missingReferenceKeys = [ 'medtab', 'dpt', 'geoc', 'pdt', 'cmsid', 'pbdt', 'asst', 'udt', 'asb', 'hcpvalid', 'regsite', 'zc', 'age', 'gender', 'QXMD_ID', 'device' ];

missingReferenceKeys.forEach((key)=>{
  if (!referenceKeys.includes(key)) {
    referenceKeys.push(key);
  }
});

window.findDmp = 0;
window.isEmed = [ "502", "503", "504", "505", "508" ].includes(
  PageMetadata.pageSegVars.cg
);
window.isDD = [ "501", "502", "503", "504", "505", "508" ].includes(
  PageMetadata.pageSegVars.cg
);

var _hostName = location.hostname.split(".")[0];
window._isODP = _hostName === "odp" || _hostName === "decisionpoint";


window.pageCurrentURL = window.location.href.toLowerCase();
window._isAnArticle = pageCurrentURL.match(/(viewarticle|artikelansicht|voirarticle|verarticulo|verartigo)/) ? true : false;

document.dispatchEvent(new CustomEvent('LibReady', { detail: 'ads' }));

document.addEventListener('DFP_DISPLAY_CALLED', function() {
  document.addEventListener('pvidReset', function(e) {
    if (window.s_pageview_id && webmd && webmd.ads2 && webmd.ads2.refresh && e && e.detail !== true) {
      debug.log("[mads][pvidReset] triggering refresh with new pageview ID");
      webmd.ads2.refresh({ keys: { pvid: s_pageview_id } });
    } else {
      webmd.ads2.setPageTarget('pvid', s_pageview_id);
    }
  });
});


document.addEventListener('userIDComplete', function(data) {
  debug.log("[userIDComplete] event Called");
  window.readyPulsePoint = true;
  ibAds.init();
});

// Variable for the Current Page URL as we use this data many times
// is references in the collapsead script
window.pageCurrentURL = window.location.href.toLowerCase();

window.ibAds = {
  init() {
    if (!window.inItOnce) {
      debug.log("[ibAds] init inside");
      profads.ads2 = ibAds;
      webmd.ads2.addSlotRenderEndedCallback('ads-pos-1145_1', profads.ads2.logictoDisplayHTML5);
      window.inItOnce = true;
      if (typeof window.PageMetadata == 'undefined' && typeof window.DFPTargetKeys == 'object') {
        window.PageMetadata = window.DFPTargetKeys;
      } else if (typeof window.PageMetadata == 'object' && typeof window.DFPTargetKeys == 'object') {
        window.PageMetadata = Object.assign({}, window.DFPTargetKeys, window.PageMetadata);
      }
      const self = this;
      self.staticTargetKeys = staticTargetKeys;
      self.dynamicTargetkeys = dynamicTargetkeys;

      self.enableHeaderBidding = true;
      SetProfSizes();
      self.utils = utils;
      //self.frameworkName = self.utils.frameworkName().toLowerCase();
      //self.settings = settings;
      // init was already called
      if (self.init.flag) {
        debug.warn("[Ibads]Init was already called");
        return;
      }
      self.thirdPartyModules = [ meads, doubleVerify ];
      self.allowedMediaNet = [ 'medscape.com' ];
      self.allowedMediaNet.forEach((v, i) =>{
        if (location.host.indexOf(v) !== -1) {
          self.thirdPartyModules.push(medianet);
        }
      })
      self.init.flag = true;
      self.makeAliases();
      if (PageMetadata.reqHeaders.device == "PC" && ibAds.utils.getBrkPnt() == "1") {
        PageMetadata.reqHeaders.device = "MOBILE";
      }
      ProfAdsIgnore();
      self.load3rdPartyModules();
      self.initializeWebmdAds(); // initialize webmd
      self.isMobile = self.utils.getBrkPnt() === 'bp1';
      self.pbr = (PageMetadata.userSegVars && PageMetadata.userSegVars.pbr &&  (Array.isArray(PageMetadata.userSegVars.pbr) || typeof PageMetadata.userSegVars.pbr === "string"))
        ? PageMetadata.userSegVars.pbr.slice() : null;
      self.spbr = {};
      self.hostSafeList = [ 'medscape', 'googlesyndication', 'mdedge', 'univadis', '2mdn' ];
      // alias function names from Medscape
      self.mutationTargets = [];
      self.addEventListeners.call(this);
      webmd.ads2.googleDefer(function() {
        webmd.ads2.setPageTarget('saf', self.getCookie('ads_saf') ||  0);
      });
    }

    if (typeof window.libLoadStatus == 'undefined' || window.libLoadStatus.complete) {
      let scope = window.ibAds;
      window.PageMetadata = Object.assign({}, window.DFPTargetKeys, window.PageMetadata);
      if (document.readyState === 'interactive' || document.readyState === 'complete') {
        scope.makeAdCall();
      } else {
        document.addEventListener('readystatechange', (e) => {
          if (document.readyState === 'complete') scope.makeAdCall();
        });
      }
    }
  },
  makeAliases() {
    debug.log("[ibAds][makeAliases] inside");
    this.getIframeParentElement = this.utils.getAdParentElement;
    //this.aggressiveDriver = this.insertLayerAd;
    this.returnHostMessage = this.utils.returnHostMessage;
    this.nativeGraphic = this.utils.nativeGraphic;
    this.setPIMC = this.utils.setPIMC;
    this.updatePIMC = this.utils.updatePIMC;
    this.addRepConnect = addRepConnect;
  },
  initializeWebmdAds() {
    debug.log("[ibAds][initializeWebmdAds] inside");
    webmd.ads2.init();
    webmd.ads2.slotRenderEnded();
  },
  getLineItemId(data) {
    debug.log("[ibAds][getLineItemId] inside");
    var lid = data.lid;
    var matched = sessionStorage.getItem('matched');
    var getLid = sessionStorage.getItem('lid');
    var correlator = sessionStorage.getItem("correlator");
    if (data.lid !== null && matched !== "1" && (correlator === null || correlator == googletag.pubads().getCorrelator())) {
      sessionStorage.setItem("correlator", googletag.pubads().getCorrelator());
      sessionStorage.setItem("lid", lid);
      webmd.ads2.setPageTarget('lif', lid);
    }
    else {
      webmd.ads2.setPageTarget('lif', getLid);
    }
  },
  lineItemId() {
    debug.log("[ibAds][lineItemId] inside");
    /*start of line item id */
    if (_isAnArticle) {
      let data = sessionStorage.getItem('article');
      let pathName = location.pathname.split("/");
      let articleId = pathName[pathName.length - 1];
      if (articleId.indexOf("_") !== -1) {
        let article = articleId.split("_");
        let articleIdNumber = article[0];
        if (data == articleIdNumber) {
          sessionStorage.setItem("matched", "1");
          webmd.ads2.setPageTarget('lif', sessionStorage.getItem('lid') == null ? 0 : sessionStorage.getItem('lid'));
        }
        else {
          sessionStorage.removeItem("matched");
          sessionStorage.removeItem('lid');
          sessionStorage.removeItem("correlator");
          sessionStorage.setItem("article", articleIdNumber);
        }
      }
      else {
        sessionStorage.removeItem("matched");
        sessionStorage.removeItem('lid');
        sessionStorage.removeItem("correlator");
        sessionStorage.setItem("article", articleId);
      }
    }
    else {
      sessionStorage.removeItem("matched");
      sessionStorage.removeItem('lid');
      sessionStorage.removeItem("correlator");
      sessionStorage.removeItem('article');
    }
    /*end of line item id */

  },
  messageHandler(event) {
    const self = this;
    function isSafe() {
      return self.hostSafeList.filter((host) => {
        return event.origin.indexOf(host) !== -1;
      }).length > 0;
    }

    // only allow postMessages from white listed domains with a valid callback function
    if (isSafe()) {
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : (typeof event.data === 'object' ? event.data : { event });

        if (data.callback) data.callBack = data.callback;
        if (data.callBack && typeof this[data.callBack] === 'function') this[data.callBack](data, event.origin);
      } catch (e) {
        debug.warn('unable to parse json: ', e);
      }
    }
  },
  addEventListeners() {
    const self = this;
    // listen to the 'collapse' event from collapse-ad.js
    window.addEventListener('collapse', (e) => {
      var adPosDiv = document.getElementById(e.detail.parent);
      if (adPosDiv === null) {
        return adPosDiv;
      } else {
        var wrapperClass = 'ad-wrapper';
        var wrapper = document.getElementById(e.detail.parent);
        var parentCount = 3;
        for (var i = 0; i <= 3; i++) {
          if (typeof wrapper.classList === 'undefined') {
            break;
          } else if (wrapper.classList.contains(wrapperClass)) {
            break;
          } else {
            wrapper = wrapper.parentNode;
          }
        }
        var collapseDiv = adPosDiv;
        if (typeof wrapper.classList !== 'undefined' && wrapper.classList.contains(wrapperClass)) {
          collapseDiv = wrapper;
        }
        collapseDiv.style.display = 'none';
        return collapseDiv;
      }
    }, false);
    window.addEventListener('alters-complete', () => {
      // this may be triggered before ibads is initialized. It indicates when slotKeys are available.
      self.altersComplete = true;
    });
    window.addEventListener('addCompReportDriver', self.addCompReportDriver);
    window.addEventListener('message', self.messageHandler.bind(self));
    window.addEventListener('displayAggressiveDriver', self.aggressiveDriver.bind(this));
    window.addEventListener('ibads:ready', () => { // event is triggered by makeAdCall()
      // self.initializeWebmdAds(); // initialize webmd
      self.affiliateName = self.utils.getAffiliateDomain();
      if (self.affiliateName) document.body.classList.add(`affiliate-${self.affiliateName}`); // add body class with affiliate name for CSS use
    })
    window.addEventListener('displayAdhesiveFooter', (e)=>{self.displayAdhesiveFooter(e.detail);});
    window.addEventListener('textAdRender', (e) => {
      const adTextAdDiv = document.getElementById(e.detail.iframe).parentNode.parentNode;
      adTextAdDiv.classList.add('textAdClass');
    }, false);
  },
  addMutationListener(config) {
    // for proof of concept only, but could also be used to collapse ad
    return;

    const mutateConfig = Object.assign({
      attributes: true,
      childList: true,
      subtree: true
    }, config.options);

    const callback = (mutationsList) => {
      for (let mutation of mutationsList) {
        switch (mutation.type) {
        case 'childList':
          // perform action on element
          break;
        case 'attributes':
          if (config.callBack && typeof config.callBack === 'function') config.callBack.call(null, mutation.target);
          break;
        }
      }
    }

    const observer = new MutationObserver(callback);
    this.mutationTargets.push({ ele: config.target, mObserver: observer });
    observer.observe(config.target, mutateConfig);
    // Later, you can stop observing
    //observer.disconnect();
  },
  callBacks: {
    hasBlankAd(target) {
      debug.log('%c mutation target sent to hasBlankAd()', 'background: #C63607; color: #fff;', target.classList.contains('blank-ad'), target.id);
    }
  },
    insertParallax(e) {
        const that = this;
        that.utils.loadScript({
            src: `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/external/parallax.js`,
            loadHandler() { profads.ads2.initParallax(e) },
            errorHandler() { console.error('parallax script failed to load.') },
            async: true,
            cors: true
        });
        return that;
    },
    insertImpactPoll(e) {
      const that = this;
      that.utils.loadScript({
          src: `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/external/impactpoll.js`,
          handler() {  profads.ads2.initImpactPoll(e); },
          errorHandler() { console.error('Impact poll script failed to load.'); },
          async: true,
          cors: true
      });
      return that;
  },
  insertAdhesiveVideo(e) {
    debug.log("[ibAds][insertAdhesiveVideo] inside");
    const that = this;
    that.utils.loadScript({
      src: `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/external/mdscp-adhesive-video.js`,
      loadHandler() { that.initAdhesiveVideo(e) },
      errorHandler() { console.error('Adhesive video script failed to load.') },
      async: true
    });
  },
  displayAdhesiveFooter(e) {
    debug.log("[ibAds][displayAdhesiveFooter] inside");
    const that = this;
    /*
         legacy code, in use undetermined
         */
    window.checkHTML5Creative = false;
    let elements = document.querySelectorAll('.adhesive-footer-wrapper');
    elements.forEach((element) => { element.style.display = 'block'});
    that.utils.loadScript({
      src: `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/medscape/external/mdscp-adhesive-footer.js`,
      handler() { that.initAdhesiveFooter(e) },
      errorHandler() { console.error('Adhesive footer script failed to load.') },
      async: true,
      cors: true
    });

    return that;
  },
  insertLayerAd(data) {
    debug.log("[ibAds][insertLayerAd] inside");
    const that = this;
    let config = data.detail === undefined ? data : data.detail;
    let delay = config.delay || 0;
    new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(config);
        if (!config) reject('event config not defined');
      }, delay);
    }).then(config => {
      // the new name of the cpc layer is NativeConnect, so we want to map the names for future use
      const layerType = [
        { 'LLR': 'LLR' },
        { 'layer-cpc': 'NativeConnect' },
        { 'native-footer': 'NativeFooter' },
        { 'toaster': 'Toaster' },
        { 'promo-layer': 'PromoLayer' },
        { 'ecx-layer': 'ECXLayer' },
      ].filter(l => Object.keys(l)[0] === config.productType)[0];

      const layerName = Object.values(layerType)[0];
      const fileName = `${layerName.toLowerCase()}.js`;
      config.layerType = layerName;

      // do not load more than once
      if (typeof ibAds[layerName] === 'function') return;

      this.utils.loadScript({
        src: `//img${this.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/layerads/${fileName}`,
        loadHandler() {
          if (typeof ibAds[layerName] !== 'function') return;
          // this if() refers to the Class name declared in the file for the class. Example: frameWork['NativeConnect'] = class NativeConnect extends LayerAd
          const NativeAdCLass = ibAds[layerName].name + 'LayerAd';
          //ibAds[layerName] is the class extended from the LayerAd class
          //ibAds[NativeAdCLass] is an instance of that class
          ibAds[NativeAdCLass] = new ibAds[layerName](config);
          ibAds[NativeAdCLass].render();
        },
        errorHandler(err) { console.error('Layer ad script failed to load.', err) },
        async: true
      });
    }).catch(err => { console.error('insertLayerAd error: ', err) });

    window.addEventListener('layerLoaded event: ', (e) => { console.log('on layerLoaded', e.detail) });
  },
  postOmnitureData(data) {
    debug.log("[ibAds][postOmnitureData] inside");
    // check if Beacon is present
    if (typeof s_md !== 'object' && typeof wmdPageLink !== 'function') return;
    if (typeof data.extLink !== "undefined") {
      let exitLink = data.extLink;
      [ 'http://', 'https://', 'www.' ].forEach(x=>{
        if (exitLink.indexOf(x) !== -1) exitLink = exitLink.slice(x.length);
        if (exitLink.lastIndexOf('/') === exitLink.length - 1) exitLink.slice(0, exitLink.indexOf('/'));
      });
      exitLink.indexOf('medscape.com') === -1 ? wmdSetContext('wb.exiturl', 'exit::' + exitLink) : wmdSetContext('wb.cstm', 'landpg::' + exitLink);
    }
    if (typeof data.textLink !== "undefined")  s_md.contextData['wb.lnktxt'] = data.textLink;
    if (typeof data.sact !== "undefined") s_md.contextData['wb.sact'] = data.sact;
    if (typeof data.sprod !== "undefined") s_md.contextData['wb.sprod'] = data.sprod;    
    if (typeof data.qacseg !== "undefined") { 
        wmdSetContext({'wb.qacseg': data.qacseg});
        addLinkTrackVars('wb.qacseg');        
    }

    wmdPageLink(data.mmodule + "_" + data.mlink);

    if (typeof data.callBack === 'function') data.callBack();

    // reset context
    if (typeof data.textLink !== "undefined") s_md.contextData['wb.lnktxt'] = "";

  },
  adTracking: {
    track: function (string, url) {
        wmdPageLink(string);
    },
    extLink: function (string, url) {
        wmdSetContext('wb.exiturl', 'exit::' + url);
        wmdPageLink(string);
        wmdRemContext('wb.exiturl');
    },
    intLink: function (string, url) {
        wmdSetContext('wb.cstm', 'landpg::' + url);
        wmdTrack(string);
        wmdRemContext('wb.cstm');
    },
    isInternalExternal: function (url) {
        const urlArray = url.split('/');
        let destination;
        if (urlArray.indexOf('medscape') !== -1 || urlArray[0].charAt[0] === '/') {
            destination = 'internal';
        } else {
            destination = 'external'
        }
        return destination;
    }
  },
 // Confluence reference: https://confluence.webmd.net/display/ProfessionalDev/Omniture+IFI+tracking
 trackNative: function (data) {
    wmdSetContext('wb.lnktxt', data.text);
    if (this.adTracking.isInternalExternal(data.href) === 'external') {
        this.adTracking.extLink(data.track, data.href);
    } else {
        this.adTracking.intLink(data.track, data.href);
    }
  },
  postCpData(cpdata, Cpcallback) {
    debug.log("[ibAds][postCpData] inside");
    if (pageCurrentURL.indexOf('medscape.com') !== -1) {
      delete cpdata.callBack;
      cpdata.uid =  (PageMetadata.userSegVars && PageMetadata.userSegVars.gd && PageMetadata.userSegVars.gd.toString()) || '';

      if (typeof cpdata.url == 'undefined') {
        cpdata.url = encodeURIComponent(window.location.href.split("?")[0]);
      }
      cpdata.date = new Date().getTime();
      let cpJSON = JSON.stringify(cpdata);
      const ajaxUrlPath = `//api${this.utils.getEnvironment()}.medscape.com/cp/events.json`;

      function jsonp(url, url2, callbackCp) {
        var callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
        window[callbackName] = function(data) {
          delete window[callbackName];
          document.body.removeChild(script);
          if (typeof callbackCp == 'function') {
            callbackCp(data);
          }
        };
        var script = document.createElement('script');
        script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName + url2;
        document.body.appendChild(script);
      }
      jsonp("https:" + ajaxUrlPath, "&event=" + cpJSON, function() {
        if (typeof callback != 'undefined' && typeof callback == 'function') {
          Cpcallback();
        }
      });
    }
  },
  inFocusBadge: function(data) {
    debug.log("[ibAds][inFocusBadge] inside");
    let { bgColor, text } = data.payload["inFocusLabel"];

    let htmlContent = `<div class="infocus-label" style="display: inline-block;
        font-family: proxima_nova_rgregular,sans-serif;
        font-weight: 600;
        font-size: 0.75rem;
        background-color: ${bgColor ? bgColor : "#ECF5F9"};
        padding: 0.5rem 0.75rem;
        border-radius: 0.25rem;
        line-height: 0.75rem;
        letter-spacing: 0.063rem;
        text-transform: uppercase;
        ">${text ? text : "In Focus Series"}</div>`;
    console.log('InFocusBadge Event called');

    const ele = document.querySelector('.infocus-label');
    if (!ele) document.querySelector(".heading .breadcrumb").insertAdjacentHTML('afterend', htmlContent);
  },
  collapseparentElement: function(data) {
    debug.log("[ibAds][collapseparentElement] inside");
    let elementId = document.getElementById(data.slotId);
    if (elementId != null) {
      if (data.type == "Broadcast") {
        elementId.classList.add('blank-ad');
        elementId.style.display = 'none';
      }
      else {
        elementId.classList.add('adlabelblank');
      }
    }
  },
  formularyAccessApi: function(data) {
    formulary.formularyAccessApi.call(this, data);
  },
  makeAdCall() {
    debug.log("[ibAds][makeAdCall] inside");
    window.dispatchEvent(new CustomEvent('ibads:ready'));
    const self = this;
    if (self.makeAdCall.flag) {
      console.warn("makeAdCall was already called");
      return;
    }
    self.makeAdCall.flag = true;

    // Isn't doing anything yet, no exclusion or target keys to set
    self.setExcList();
    //check consent and set PPID from cookie
      try {
        self.utils.setPIMC();
      }
      catch (e) {
        console.warn("Error while setting PIMC");
      }
    ibAds.getPPID();
    self.staticTargetKeys();
    self.dynamicTargetkeys();
    //self.setTargetKeys();  sets page level targeting
    webmd.ads2.setPageTarget(self.CapTargetKeys());

    self.adDisplay();
  },
  DfpUatCap: function() {
    debug.log("[ibAds][DfpUatCap] inside");
    var urlQstringCap = window.location.href.split('?');
    var QVals = [];
    var KeyValPs = urlQstringCap[1].split("&");
    var TestAdObj = {};
    for (var i = 0; i < KeyValPs.length; i++) {
      QVals[i] = KeyValPs[i].split('=');
      TestAdObj[QVals[i][0]] = QVals[i][1];
    }
    var DfpUatVals = {
      tar: TestAdObj.tar,
      tc: TestAdObj.tc,
      pf: TestAdObj.pf,
      /*ssp:TestAdObj.ssp,ct:TestAdObj.ct,st:TestAdObj.st,*/
      usp: TestAdObj.usp,
      occ: TestAdObj.occ,
      val: TestAdObj.val
    };

    if (TestAdObj.hasOwnProperty("dt")) {
      DfpUatVals.dt = TestAdObj.dt;
    }
    return DfpUatVals;
  },
  CapTargetKeys: function(TKeysObj) {
    debug.log("[ibAds][CapTargetKeys] inside");
    let that = this;
    // set pvid val as global
    TKeysObj = TKeysObj || {};
    if (typeof window.s_pageview_id === 'undefined' || window.s_pageview_id === "") {
      this.pvid = this.utils.GenPVID();
      window.s_pageview_id = this.pvid;
    } else {
      this.pvid = window.s_pageview_id;
    }

    function assignKeys(parentObj) {
      const acceptedValues = [ "pageSegVars", "reqHeaders", "userSegVars", "webSegVars" ];
      for (let i in parentObj) {
        if (acceptedValues.includes(i)) Object.assign(TKeysObj, parentObj[i]);
        if (i == 'exclusionCategories' && parentObj[i] !== 'undefined' && typeof parentObj[i] !== 'undefined') {
          if (parentObj[i] == TKeysObj[0]) {
            delete(TKeysObj[0]);
          }
          if (typeof parentObj[i][0] !== 'undefined' && typeof parentObj[i][0].replace !== 'undefined') {
            TKeysObj['excl_cat'] = parentObj[i][0].replace(/ /g, '') || '';
          }
        }
      }
    }

    if (typeof PageMetadata !== "undefined") {
      assignKeys(PageMetadata);
    } else if (typeof AjaxTargetKeys !== "undefined") {
      assignKeys(AjaxTargetKeys);
    }

    // non virtual page
    TKeysObj.vp = '0';
    TKeysObj.uri = this.utils.sanitizeURI(window.location.pathname);
    TKeysObj.pvid = this.pvid;
    TKeysObj.cn = TKeysObj.cn || '0';
    TKeysObj.lif = sessionStorage.getItem('ibadsLif') == null ? 0 :  sessionStorage.getItem('ibadsLif');
    TKeysObj.xgdp = '0';
    if (that.isGDPR() || !utils.GDPR_optin_check()) {
      TKeysObj.xgdp = '1';
    }
    //stick key logic
    TKeysObj.stick = '0';
    if (PageMetadata.reqHeaders.domainCategory != 'cme' && PageMetadata.reqHeaders.device == 'PC') {
      if (pageCurrentURL.indexOf('viewarticle') !== -1) {
        TKeysObj.stick = '7,31';
      } else if (PageMetadata.pageSegVars && PageMetadata.pageSegVars.pc && PageMetadata.pageSegVars.pc.indexOf('slideshow') !== -1) {
        if (locale == 'us') {
          TKeysObj.stick = '23';
        }
      } else if (PageMetadata.pageSegVars.art != "0") {
        if (pageCurrentURL.indexOf('emedicine') !== -1 || pageCurrentURL.indexOf('reference') !== -1) {
          TKeysObj.stick = '16,41';
          if (typeof s_test1 !== 'undefined') {
            if (s_test1 == "ott-tlb_ctrl")
              TKeysObj.stick = '51,41';
            else if (s_test1 == "ott-tlb_test1")
              TKeysObj.stick = '52,41';
          }
        }
      }
    } else if (typeof breakpoint != 'undefined' && breakpoint == 1) {
      if (pageCurrentURL.indexOf('viewarticle') !== -1) {
        TKeysObj.stick = '61';
      } else if (pageCurrentURL.indexOf('emedicine') !== -1 || pageCurrentURL.indexOf('reference') !== -1) {
        TKeysObj.stick = '71';
      }
    }
    if (pageCurrentURL.indexOf('mtv') !== -1) {
      if (PageMetadata.reqHeaders.device == 'MOBILE') {
        TKeysObj.stick = '61';
      } else if (PageMetadata.reqHeaders.device == 'PC') {
        TKeysObj.stick = '63';
      } else if (PageMetadata.reqHeaders.device == 'IPAD') {
        TKeysObj.stick = '62';
      } else {
        TKeysObj.stick = '63';
      }
    }
    //end of stick key logic
    //msi key logic
    if (PageMetadata.reqHeaders.domainCategory != 'cme' && PageMetadata.reqHeaders.device == 'MOBILE') {
      if (PageMetadata.pageSegVars.pc && PageMetadata.pageSegVars.pc.indexOf('slideshow') !== -1) {
        if (typeof s_test2 !== 'undefined') {
          if (s_test2 == "ott-msi_ctrl")
            TKeysObj.msi = '0';
          else if (s_test2 == "ott-msi_test1")
            TKeysObj.msi = '1';
          else if (s_test2 == "ott-msi_test2")
            TKeysObj.msi = '2';
          else if (s_test2 == "ott-msi_test3")
            TKeysObj.msi = '3';
        } // end if
      } // end if
    }
    //bp brkpoint key logic
    if (typeof s_responsive_design !== 'undefined' && s_responsive_design)
      TKeysObj.bp = that.utils.getBrkPnt();
    //end of bp logic
    if (window.location.href.indexOf("DfpUat") !== -1) {
      var NewUATVals = that.DfpUatCap();
      TKeysObj.occ = NewUATVals.occ;
      TKeysObj.pf = NewUATVals.pf;
      TKeysObj.tar = NewUATVals.tar;
      TKeysObj.tc = NewUATVals.tc;
      if (NewUATVals.usp !== '0') {
        TKeysObj.usp = NewUATVals.usp;
      }

      if (NewUATVals.hasOwnProperty("dt")) {
        TKeysObj.dt = NewUATVals.dt;
      }

      TKeysObj.val = NewUATVals.val;
    }
    Object.keys(TKeysObj).forEach((obj) => {
      TKeysObj[obj] = that.cleanTargetKey(TKeysObj[obj]);
    });

    const filterObject = (obj, referenceKeys) => {
      Object.keys(obj).forEach((key) => {
        if (!referenceKeys.includes(key.toLowerCase())) {
          unMatchedKeys.push(key);
          delete obj[key];
        };
      });
    };

    filterObject(TKeysObj, referenceKeys);
    console.warn('Unsupported target keys found: ', unMatchedKeys);

    return TKeysObj;
  },
  setExcList() {
    debug.log("[ibAds][setExcList] inside");
    const self = this;
    let excList = [];
    if (typeof PageMetadata !== "undefined" && typeof PageMetadata.exclusionCategories !== "undefined") {
      excList = PageMetadata.exclusionCategories;
    } else if (typeof AjaxTargetKeys !== "undefined" && typeof AjaxTargetKeys.exclusionCategories !== "undefined") {
      excList = AjaxTargetKeys.exclusionCategories;
    }
    if(!utils.GDPR_optin_check()){
      excList.push('limited');
    }
    excList = [ ...excList, ...self.gdprExclusion() ];
    if (excList.length > 0) {
      webmd.ads2.setPageExclusion(excList);
    }
  },
  setTargetKeys() {
    debug.log("[ibAds][setTargetKeys] inside");
    const targetKeys = {};
    webmd.ads2.setPageTarget(targetKeys);
  },
  adDisplay() {
    debug.log("[ibAds][adDisplay] inside");
    const self = this;
    const slotsAvailable = typeof adsPosSettings.slotKeys === 'object' || self.altersComplete;
    const delay = slotsAvailable ? 0 : 2000;
    // for 3rd parties using profads, use data-attribute collection method to invoke defineAds() on div, instead of including an inline <script> tag
    new Promise((resolve, reject) => {
      setTimeout(() => {
        const dataAds = self.collectDataAds.call(self, slotsAvailable);
        if (dataAds) {
          resolve(dataAds);
        } else {
          reject(new Error('no dataAds available'));
        }
      }, delay);

    }).then((result) => {
      webmd.ads2.display();
    }).catch((error) => {
      console.error('catch: no dataAds available', error);
    });
  },
  getASID(pos) {
    const self = this;

    // check if the pbr values are present
    let pbr = self.pbr;

    if (!pbr || !self.utils.isEmptyObject(pbr)) return null;

    // get the sizes of give pos and convert into string
    let sizes = webmd.ads2.sizes[pos];
    if (!sizes)
      return null;
    let strsizes = "";
    let len = sizes.length;
    for (let i = 0; i < len; i++) {
      strsizes += (typeof sizes[i] === 'string' ? sizes[i] : sizes[i].join("x"));
      if (i != len - 1) strsizes += ",";
    } // end for

    // check if the the size in the pbr matches this pos adslot sizes

    let spbr = {}; // slot level pbr object
    for (let i = 0; i < pbr.length; i++) {
      if (strsizes.indexOf(pbr[i].w + "x" + pbr[i].h) > -1) {
        spbr.a = pbr[i].a;
        spbr.pdp = pbr[i].pdp;
        spbr.pds = pbr[i].pds;
        spbr.pdi = pbr[i].pdi;
        self.ads2.spbr[pos] = spbr;
        //cache all values under each pos

        if (pbr.length <= 0) { self.pbr = null; }
        return spbr;
      } // end if
    } // end for
    return null; // return 0 if no matching size
  },
  getSlotVals(id) {
    debug.log("[ibAds][getSlotVals] inside", id);
    const slotKeys = window.adsPosSettings.slotKeys;
    if (typeof slotKeys === 'object') {
      let slotObj = slotKeys.filter(s => {
        return Object.keys(s)[0] === id;
      })[0];
      return typeof slotObj === 'undefined' ? undefined : slotObj[id] ;
    }
  },
  collectDataAds(slotVals) {
    const self = this;
    const ads = Array.from(document.querySelectorAll('[data-ad-unit="true"]'));
    document.querySelectorAll("[id^='ads-']").forEach(function(adsDiv) {
      adsDiv.classList.add('globalpromoadsunit');
    });
    debug.log("[ibAds][collectDataAds] inside", ads);
    ads.forEach(ad => {
      const slotKeys = self.getSlotVals.call(self, ad.id) || {};
      webmd.ads2.defineAd({
        id: ad.id,
        pos: ad.dataset.adPos,
        keys: slotKeys
      });
    });
    return ads;
  },
  load3rdPartyModules: function() {
    debug.log("[ibAds][load3rdPartyModules] inside");
    window.ibAds.thirdPartyModules.forEach(m => {
      let mod = m.init.call(m);
      // test if module returns a promise, assign to profads, currently only used for lotame
      if (typeof mod === 'object' && mod.hasOwnProperty('promise'))   window.ibAds[m.name] = mod;
      if (m.callBack) webmd.tpsvc.cmds.push(m.callBack.bind(m));
    });
  },
  aggressiveDriver: function(config) {
    debug.log("[ibAds][aggressiveDriver] inside", config);
    let that = this;
    let layerName = "aggressiveDriverExt";
    let fileName = "mdscp-aggressivedriver-meads.js";

    if (typeof that[layerName] === 'function') {
      that[layerName](config);
      return;
    }
    that.utils.loadScript({
      src: `https://img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/layerads/${fileName}`,
      loadHandler() {
        if (typeof that[layerName] !== 'function') return;
        // this if() refers to the Class name declared in the file for the class. Example: frameWork['NativeConnect'] = class NativeConnect extends LayerAd
        that[layerName](config);
      },
      errorHandler(err) { console.error('aggressiveDriver ad script failed to load.', err) },
      async: true
    });
  },
  invMobileFooter: function(config) {
    debug.log("[ibAds][invMobileFooter] inside", config);
    let that = this;
    let layerName = "invMobileFooterExt";
    let fileName = "mdscp-invmobilefooter-meads.js";

    if (typeof that[layerName] === 'function') {
      that[layerName](config);
      return;
    }
    that.utils.loadScript({
      src: `https://img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/layerads/${fileName}`,
      loadHandler() {
        if (typeof that[layerName] !== 'function') return;
        // this if() refers to the Class name declared in the file for the class. Example: frameWork['NativeConnect'] = class NativeConnect extends LayerAd
        that[layerName](config);
      },
      errorHandler(err) { console.error('invMobileFooter meads ad script failed to load.', err) },
      async: true
    });
  },
  /*
    * Display Manufacturers Announcment Layer
    * */
  displayMANLayer: function(adNode) {
    debug.log("[ibAds][displayMANLayer] inside", adNode);
    // DO NOT load MAN Layer on landscape orientation in mobile
    const originContainer = document.getElementById('man-layer-id');
    if (window.matchMedia("(orientation: landscape)").matches == true && this.utils.getBrkPnt() == 1) {
      return;
    }
    const bodyClass = 'man-layer-visible';
    const closeClass = 'man-close';
    const body = document.body.classList.add(bodyClass);
    const manContent = adNode;
    manContent.classList.add('man-content');
    const whiteOutLayer = this.utils.createElement({
      name: 'div',
      className: 'man-whiteout-layer'
    });
    this.whiteOutLayer = whiteOutLayer;
    const manHeader = this.utils.createElement({
      name: 'div',
      className: 'man-header',
      children: [
        {
          name: 'span',
          className: 'man-ifi',
          text: 'Information from Industry'
        },
        {
          name: 'span',
          className: 'man-header-title',
          text: 'Manufacturer Announcement'
        },
        {
          name: 'span',
          className: closeClass,
          text: 'close'
        }
      ]
    });
    const manLayer = this.utils.createElement({
      name: 'div',
      className: 'man-ad-layer',
      id: 'man-layer'
    })

    manLayer.append(manHeader);
    manLayer.append(manContent);


    document.body.append(whiteOutLayer)
    document.body.append(manLayer);
    addCloseHandler(closeClass);

    function addCloseHandler(closeClass) {
      document.body.addEventListener('click',  closeMAN);
      document.body.addEventListener('click', closeMAN);
    }

    function closeMAN(e) {
      // do not close if on different page than the creative
      if (e.target.classList.contains('MAN_CTA_CLOSE')) {
        const url = e.target.dataset.url ? e.target.dataset.url : e.target.href;
        const articleID = PageMetadata.pageSegVars.art.replace('drg', '');
        if (url.indexOf(articleID) === -1) {
          window.open(url);
          return;
        }
      }
      whiteOutLayer.style.display = 'none';
      manLayer.remove();
      if (originContainer) {
        originContainer.remove();
      }
      document.body.classList.remove(bodyClass);
      wmdPageLink('man_dsms', e.target);
    }
    try {
      profads.ads2.updatePIMC();
    } catch (e) {
      console.warn("Error occured in updating PIMC");
    }
    return manLayer;
  },
  /*
    Interscroller functionality
    */
  interscrollerInit: function(data) {
    debug.log("[ibAds][interscrollerInit] inside", data);
    const self = this;
    self.loadCSS();
    const interscroller = document.getElementById(data.slotId);
    const interscrollerIframe = interscroller.querySelector('iframe');
    interscroller.classList.add('interscroller');
    interscrollerIframe.width = "100%";

    if (interscroller.parentNode.classList.contains('ad-item')) {
      interscroller.parentNode.classList.remove('ad-item');
      interscroller.parentNode.style.width = '100%';
    }
    // video player disable
    if (location.href.includes('mdalert')) {
      jwplayer('mdavPlayer').setFloating(false);
    }
  },
  loadCSS() {
    const that = this;
    let path = `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/css/layers/ibads-interscroller.css`;
    let css = that.utils.createElement({
      name: 'link',
      attributes: [
        { rel: 'stylesheet' },
        { href: path },
        { type: 'text/css' },
        { media: 'screen' }
      ],
      eventHandler: {
        eventName: 'load',
        fn() {
          console.log(`%c ${nameSpace} Layer ad css loaded `);
        }
      }
    });
    that.utils.appendExternalNode(css, document.head);
    return css;
  },
  removeMEKeys: function(event) {
    debug.log("[ibAds][removeMEKeys] inside");
    var meArray = [ "rord", "mcs", "imid", "moa", "mop", "oaw" ]
    for (var i = 0;i < meArray.length;i++) {
      if (event.slot.getTargeting(meArray[i]).length == 1) {
        event.slot.clearTargeting(meArray[i])
      }
    }
  },
  postECXInvitation: function(data) {
    debug.log("[ibAds][postECXInvitation] inside");
    let _adContainer = document.getElementById(data.slotId);//$("#"+data.slotId);
    _adContainer.classList.add('adlabelblank');
  },
  addTextAdClass: function(data) {
    debug.log("[ibAds][addTextAdClass] inside", data);
    var slotId = document.getElementById(data.id);
    if (slotId !== null) {
      slotId.classList.add('textAdClass');
    }
  },
  removePinlines: function(data) {
    debug.log("[ibAds][removePinlines] inside", data);
    const posDiv = data.slotId;
    const posEle = document.getElementById(posDiv);
    if (posEle) {
      posEle.style.borderTop = "none";
      posEle.style.borderBottom = "none";
    }
  },
  addCompReportDriver(e) {
    debug.log("[ibAds][addCompReportDriver] inside", e);
    const that = this;
    that.utils.loadScript({
      src: `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/js/dfp/layerads/comp-report-driver.js`,
      handler() {
        let element = ibAds.utils.getBrkPnt() == 1 ? "ads-af-pos-1145" : "ads-af-pos-145";
        let queryElement = ibAds.utils.getBrkPnt() == 1 ? "ads-pos-1145" : "ads-pos-145";
        const selector = '[id^="' + queryElement + '"]';
        // Select all elements with the matching IDs using the selector string
        const elements = document.querySelectorAll(selector);
        elements[0].classList.add('adlabelblank');
        elements[0].id = element;
        that.loadCompReport(e);
      },
      errorHandler() { console.error('Comp report driver script failed to load.') },
      async: true,
      cors: true
    });
    return that;
  },
  getCookie(name) {
    debug.log("[ibAds][getCookie] inside", name);
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
  },
  isGDPR() {
    debug.log("[ibAds][isGDPR] inside");
    let that = this;
    if (that.getCookie('isgdprct')) {
      return true;
    }
    return false;
  },
  gdprExclusion: function() {
    debug.log("[ibAds][gdprExclusion] inside");
    let self = this;
    var GDPRBol = [ "gdpr0" ];
    if (self.isGDPR()) {
      GDPRBol = [ "gdpr1" ];
    }
    return GDPRBol;
  },
  getECD: function() {
    debug.log("[ibAds][getECD] inside");
    let self = this;
    var ecd = 0;
    var exDate = new Date();
    exDate.setTime(exDate.getTime() + (120 * 60 * 1000));
    if (self.utils.getParam('ecd')) {
      ecd = self.utils.getParam('ecd');
      //$.cookie('prf_ecd', profads.ads2.getParam('ecd'), {domain: '.medscape.com', path: '/', expires: exDate});
      document.cookie = "prf_ecd=" + self.utils.getParam('ecd') + ";domain=.medscape.com;path=/;expires=" + exDate + ";";
    } else if (self.getCookie('prf_ecd')) {
      ecd = self.getCookie('prf_ecd');
    }
    return ecd;
  },
  uniqueArray: function(value, index, self) {
    debug.log("[ibAds][uniqueArray] inside");
    return self.indexOf(value) === index;
  },
  getUrlVars: function() {
    debug.log("[ibAds][getUrlVars] inside");
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function(m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  },
  getPageNumber: function() {
    var pageNumber = 1;
    if (_isAnArticle) {
      var getPathName = window.location.pathname;
      var splitPathName = getPathName.split("/");
      var splitArticleId = splitPathName[2].split("_");
      var getHashMatch = window.location.hash.match(/#vp_(\d+)/);
      var getHash = getHashMatch ? parseInt(getHashMatch[1]) : "";
      if (getHash == "") {
        if (splitArticleId[1] != undefined) {
          pageNumber = splitArticleId[1];
        }
      } else {
        pageNumber = getHash;
      }
    }
    debug.log("[ibAds][getPageNumber] inside", pageNumber);
    return pageNumber;
  },
  logictoDisplayHTML5: function() {
    debug.log("[ibAds][logictoDisplayHTML5] inside");
    let styles = {
      "paddingTop": '25px',
      "paddingBottom": '10px'
    };
    if (document.querySelector('.ad-wrapper div[id^="ads-pos-1145"]') != null) {
      document.querySelector('.ad-wrapper div[id^="ads-pos-1145"]').parentElement.parentElement.id = 'adhesive-footer-wrapper';
      document.querySelector('.ad-wrapper div[id^="ads-pos-1145"]').parentElement.id = 'adhesive-footer_content';
    }
    if (document.getElementById("adhesive-footer_content") != null && document.getElementById("adhesive-footer-wrapper") != null) {
      document. getElementById("adhesive-footer-wrapper").className = " adhesive-footer-wrapper";
      document.getElementById("adhesive-footer_content").className = " adhesive-footer_content";
    }
    let element1145 = document.querySelector('.ad-wrapper div[id^="ads-pos-1145"]');
    let element1145Iframe = document.querySelector('.ad-wrapper div[id^="ads-pos-1145"] iframe');
    let wrapper1145 = document.querySelector('.adhesive-footer-wrapper');
    function loadCSS() {
      document.head.innerHTML += `
            <style>
            .adhesive-footer_content {
                flex-direction: column-reverse;
                display: flex;
                padding-bottom: 30px !important;
            }
            .adhesive-footer_content .label {
                font-size: 8px;
                padding-top: 8px;
                padding-bottom: 3px;
            }
            .adhesive-footer-wrapper {
                display: flex;
                background: rgb(240, 239, 239);
                justify-content: center;
                position: fixed;
                bottom: 0;
                width: 100%;
            }
            </style>`
    }
    loadCSS();
    setTimeout(function() {
      if (element1145 !== null && element1145Iframe !== null && !element1145.classList.contains('blank-ad') && window.checkHTML5Creative) {
        if (wrapper1145) {
          wrapper1145.style.display = 'flex';
        }
        Object.assign(element1145.style, styles);
        element1145Iframe.style.padding = '0px';
        element1145Iframe.style.height = 'inherit';
      }
    }, 500);
  },
  getSAF: function(data) {
    debug.log("[ibAds][getSAF] inside");
    let cookieName = 'ads_saf';
    let cookieValue = data.saf;
    document.cookie = cookieName + "=" + cookieValue + ";domain=.medscape.com;path=/";
    webmd.ads2.setPageTarget('saf', cookieValue);
  },
  cleanTargetKey(targetKey) {
    let returnKey = 0;
    switch (typeof targetKey) {
    case 'object':
      returnKey = targetKey === null ? '0' : ((Array.isArray(targetKey) && targetKey.length === 0) ? '0' : targetKey);
      break;
    case 'string':
      returnKey = targetKey.length === 0 ? '0' : targetKey;
      break;
    case 'number':
      returnKey = targetKey.toString();
      break;
    default:
      returnKey = targetKey;
    }
    return returnKey;
  },
  // Promo logic
  SetSubDOMenv: function() {
    debug.log("[ibAds][SetSubDOMenv] inside");
    var subDOMenv;
    if (typeof PageMetadata !== "undefined" && PageMetadata.reqHeaders && PageMetadata.reqHeaders.requestEnv) {
      if (PageMetadata.reqHeaders.requestEnv == '') {
        subDOMenv = PageMetadata.reqHeaders.requestEnv;
      } else {
        subDOMenv = "." + PageMetadata.reqHeaders.requestEnv;
      }
    } else {
      if (/qa01/i.test(pageCurrentURL)) {
        if (/staging/i.test(pageCurrentURL)) {
          subDOMenv = ".staging.qa01";
        } else {
          subDOMenv = ".qa01";
        }
      } else if (/qa00/i.test(pageCurrentURL)) {
        if (/staging/i.test(pageCurrentURL)) {
          subDOMenv = ".staging.qa00";
        } else {
          subDOMenv = ".qa00";
        }
      } else if (/proddev/i.test(pageCurrentURL)) {
        subDOMenv = ".proddev";
      } else if (/staging/i.test(pageCurrentURL)) {
        subDOMenv = ".staging";
      } else {
        subDOMenv = "";
      }
    }
    return subDOMenv;
  },
  percentTracked: [],
  impressionViewable: function(event, slotId) {
    debug.log("[ibAds][impressionViewable] inside");
    var iframe = document.querySelector(`div#${slotId} iframe`);
    var iframeWin = (iframe.contentWindow || iframe.contentDocument);
    var cx = {
      msg: 'ad-inview',
      slot: slotId
    };

    if (PageMetadata.reqHeaders.device == 'MOBILE') {
      // handle iframe inside friendly iframe on mobile
      if (iframeWin.document) {
        iframeWin = iframeWin.document;
      }

      var childIframe = iframeWin.querySelector('iframe');
      if (childIframe) {
        childIframe.contentWindow.postMessage(JSON.stringify(cx), '*');
      }
    } else {
      iframeWin.postMessage(JSON.stringify(cx), '*');
    }
  },
  brandAlertLauncherCB: function(eventData) {
    console.table('Starting Brandalert Launcher callback');
    const { type, payload } = eventData;
    if (type !== 'brandalert-launcher') return;
    const imgSrv = `img${this.utils.getEnvironment()}.medscapestatic.com`;
    const scriptConfig = {
      placement: document.body,
      id: 'brandalert_launcher',
      src: `//${imgSrv}/medscape-promo/brandalert_vue/4/dist/launcher/brandalert-launcher-session.js`,
      loadHandler: function() {
        window.BrandAlertLauncher.init(payload);
      }
    }
    this.utils.loadScript(scriptConfig);
    console.table('Ending Brandalert Launcher callback');
  },
  headlineBrandAlertCB(data) {
    debug.log("[ibAds][headlineBrandAlertCB] inside");
    const { actId, alertUrl } = data;
    const parentBody = window.top.document.body;
    const imgSrv = `img${this.utils.getEnvironment()}.medscapestatic.com`;
    const scriptConfig = {
      placement: parentBody,
      id: 'brandalert_launcher',
      src: `//${imgSrv}/medscape-promo/brandalert_vue/4/dist/launcher/brandalert-launcher-session.js`,
      extraAtributes: []
    }
    actId ? scriptConfig.extraAtributes.push({ 'data-ba-actid': actId }) : console.warn('ACT_ID not set on headline');
    alertUrl ? scriptConfig.extraAtributes.push({ 'data-ba-url': alertUrl }) : console.warn('alertUrl not set on headline');
    this.utils.loadScript(scriptConfig);
  },
  brandAlertCB: function(eventData) {
    // empty on purpose. If needed new article template updates to be added.
  },
  addHeightTemplate: function(data) {
    // empty on purpose. If needed new article template updates to be added.
  },
  adTrackingLoaded: false,
  adTrackingQueue: null,
  loadAdTracking: function(data) {
    debug.log("[ibAds][loadAdTracking] inside", data);
    ibAds.adTrackingQueue = ibAds.adTrackingQueue || ibAds.utils.processingQueue();
    const adData = data;

    // add page data to tracking call data
    adData.pageName = s_md.pageName;
    adData.pageURL = s_md.pageURL;

    // add data to array for processing once script has loaded
    ibAds.adTrackingQueue.enqueue(adData);

    if (!ibAds.adTrackingLoaded) { // load script once
      ibAds.adTrackingLoaded = true;
      ibAds.utils.loadScript({
        src: "//img" + ibAds.SetSubDOMenv() + ".medscapestatic.com/medscape-promo/poc-ads/adTrackingIframe.bundle.js",
        handler: function() {
          window.pocAdTracking.init();
          ibAds.adTrackingQueue.process(window.pocAdTracking.queue);
        },
        async: true
      });
    }

    if (ibAds.adTrackingLoaded && window.pocAdTracking) {
      ibAds.adTrackingQueue.process(window.pocAdTracking.queue);
    }
  },
  responsivePOCAdCB: function(data) {
    debug.log("[ibAds][responsivePOCAdCB] inside", data);
    function makeResponsive(element) {
      var parent = element.parentNode;
      if (!parent.classList.contains('AdUnit')) {
        parent.style.width = '100%';
        makeResponsive(parent);
      }
      return false;
    }
    function setIframeParentStyles(iframe) {
      // allow edge-to-edge on outside container on mobile
      iframe.parentNode.parentNode.style.position = 'absolute';
      iframe.parentNode.parentNode.style.left = '0px';
      iframe.parentNode.parentNode.style.right = '0px';
    }
    function setIframeStyles(iframe) {
      var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

      if (PageMetadata.reqHeaders.device == 'MOBILE') {
        // mobile
        if (data.productName === 'brandspot') {
          iframe.style.width = '100%';
        }
        else iframe.style.width = vw < 414 ? vw + 'px' : '414px';
        setIframeParentStyles(iframe);
      } else {
        // desktop
        if (data.productName === 'brandspot') {
          iframe.style.width = '400px';
        }

        iframe.style.display = 'block';
        iframe.style.position = 'relative';
        iframe.style.margin = '0px auto';
      }
    }

    var adIframe = document.querySelector("[id^='" + data.iframeId + "']");
    if (adIframe !== null) {
      setIframeStyles(adIframe);
      makeResponsive(adIframe);
      window.addEventListener('resize', function() {
        setTimeout(function() {
          setIframeStyles(adIframe);
        }, 100);
      });
    }
  },
  resetClassNames: function(slot) {
    let conDiv = document.getElementById(slot);
    if (conDiv) {
      if (conDiv.classList.contains('blank-ad')) {
        let ele = conDiv.parentNode;
        for (let i = 0; i <= 2 && ele; i++) {
          if (ele.classList.contains('ad-wrapper')) {
            if (ele.style.display == 'none') ele.style.display = '';
            break;
          }
          ele = ele.parentNode;
        }
      }
      let resetRegex = /adlabelifi|adlabelifg|adlabelblank|blank-ad/gi;
      let adClass = conDiv.className.replace(resetRegex, '').trim();
      conDiv.className = adClass;
      conDiv.classList.add('globalpromoadsunit', 'AdUnit', 'adunit');
    }
  },
  comparePriceObjects: function(obj1 = {}, obj2 = {}) {
    debug.log("[ibAds][comparePriceObjects] inside");
    const result = {};
    for (let key in obj1) {
      if (obj2.hasOwnProperty(key)) {
        result[key] = obj1[key] > obj2[key] ? "me" : "proc";
      }
    }
    return result;
  },

  getPPID() {
    const ppidExists = document.cookie.match(/ppid=[a-zA-Z0-9]+/);
    const ppidValue = ppidExists ? ppidExists[0].split('=')[1] : ibAds.setPPID();
    if (ppidValue) {
      debug.log("[ibAds][getPPID] inside", ppidValue);
      webmd.ads2.setPublisherProvidedId(ppidValue);
    }
  },

  setPPID() {
    function setPPIDExpiry() {
      let now = new Date(); // current date
      let currentTime = now.getTime();//in millisecs
      let expireTime = currentTime + 180 * 24 * 60 * 60 * 1000; // expire after 180 days
      now.setTime(expireTime);
      debug.log("[ibAds][setPPID] inside");
      return now.toUTCString();
    }
    function generatePPID(length = 42) {
      debug.log("[ibAds][generatePPID] inside");
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      let timestamp = Math.round(Date.now() / 1000);
      return result + timestamp;
    }

    const ppidValue = generatePPID();
    const domain = window.location.host.split('.').slice(-2).join('.');
    document.cookie = `ppid=${ppidValue};expires=${setPPIDExpiry()};domain=.${domain};path=/;secure`;
    try {
      profads.ads2.setPIMC(0, true);
    } catch (e) {
      debug.warn("Error occured while resetting PIMC");
    }
    return ppidValue;
  },
  repClickHandler(version, device, mlink) {
    wmdPageLink("media-repc-embd-lnk_" + mlink);
  },
};

